import { render, staticRenderFns } from "./CostEditor.vue?vue&type=template&id=64b12232"
import script from "./CostEditor.vue?vue&type=script&lang=js"
export * from "./CostEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports